
export class Roleslisted {
  constructor(public id: string, public name: string) {}
}

export class User {
  email: string
  emailConfirmed: boolean
  expires: number
  firstName: string
  isSuccess: boolean
  lastName: string
  phoneNumber: string
  phoneNumberConfirmed: boolean
  refreshtoken: string
  token: string
  userName: string
  verifyChoice: string

  constructor(data: any) {
    this.email = data.email
    this.emailConfirmed = data.emailConfirmed === '1'
    this.expires = data.expires
    this.firstName = data.firstName
    this.isSuccess = data.isSuccess
    this.lastName = data.lastName
    this.phoneNumber = data.phoneNumber
    this.phoneNumberConfirmed = data.phoneNumberConfirmed
    this.refreshtoken = data.refreshtoken
    this.token = data.token
    this.userName = data.userName
    this.verifyChoice = data.verifyChoice
  }
}
